export default "<audio controls> Your browser does not support playing audio. Please download the file to listen to it. </audio> ";